import type { SgBootstrapTheme } from '@sgwt/sgwt-widgets-react';
import { isAllowedLang } from 'locales';
import type { MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import { getUserPreferencesLanguage } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import {
  userPreferencesDarkModeChanged,
  userPreferencesLanguageChanged,
} from 'state/userPreferences/userPreferences.action';

interface StateProps {
  currentLanguage: string;
}

interface DispatchProps {
  onLanguageChanged: (lang: string) => void;
  onThemeChanged: ({ theme }: { theme: SgBootstrapTheme }) => void;
}

export type AccountCenterProps = StateProps & DispatchProps;

export const mapStateToProps: MapStateToProps<StateProps, {}, AppState> = (state: AppState): StateProps => {
  const currentLanguage = getUserPreferencesLanguage(state);
  return {
    currentLanguage,
  };
};

function mapDispatchToProps(dispatch: ThunkDispatch): DispatchProps {
  return {
    onLanguageChanged(lang) {
      dispatch(userPreferencesLanguageChanged(isAllowedLang(lang) ? lang : 'en'));
    },
    onThemeChanged({ theme }) {
      dispatch(userPreferencesDarkModeChanged(theme === 'dark'));
    },
  };
}

export const connectAccountCenter = connect<StateProps, DispatchProps, {}, AppState>(
  mapStateToProps,
  mapDispatchToProps,
);
